import { Box, Heading, Tabs, Tab, TabList } from '@chakra-ui/react';
import { LDFlagSet } from 'launchdarkly-js-sdk-common';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { useHistory } from 'react-router-dom';

const tabIndexes = {
  user: 0,
  bankAccounts: 1,
  bankIntegrations: 2,
  notifications: 3,
  webhooks: 4,
  assignmentStrategy: 5,
};

export const SettingsViewTemplate = withLDConsumer()(
  ({
    children,
    selectedTab,
    flags,
  }: {
    children: React.ReactChild | React.ReactChild[];
    selectedTab:
      | 'user'
      | 'bankAccounts'
      | 'bankIntegrations'
      | 'notifications'
      | 'webhooks'
      | 'assignmentStrategy';
    flags?: LDFlagSet;
  }) => {
    const history = useHistory();
    return (
      <>
        <Heading as="h2">Settings</Heading>

        <Tabs
          variant="line"
          index={tabIndexes[selectedTab]}
          colorScheme="black"
        >
          <TabList>
            <Tab
              _selected={{ fontWeight: 'bold', borderBottom: '2px' }}
              pl="0"
              pr="0"
              mr={10}
              onClick={() => history.push(`/settings/user`)}
            >
              User Information
            </Tab>
            <Tab
              _selected={{ fontWeight: 'bold', borderBottom: '2px' }}
              pl="0"
              pr="0"
              mr={10}
              onClick={() => history.push('/settings/bank-accounts')}
            >
              Bank Accounts
            </Tab>
            <Tab
              _selected={{ fontWeight: 'bold', borderBottom: '2px' }}
              pl="0"
              pr="0"
              mr={10}
              onClick={() => history.push('/settings/bank-integrations')}
            >
              Bank Integrations
            </Tab>
            <Tab
              _selected={{ fontWeight: 'bold', borderBottom: '2px' }}
              pl="0"
              pr="0"
              mr={10}
              onClick={() => history.push(`/settings/notifications`)}
            >
              Notifications
            </Tab>
            <Tab
              _selected={{ fontWeight: 'bold', borderBottom: '2px' }}
              pl="0"
              pr="0"
              mr={10}
              onClick={() => history.push('/settings/webhooks')}
            >
              Webhooks
            </Tab>
            {flags?.displayAssignment && (
              <Tab
                _selected={{ fontWeight: 'bold', borderBottom: '2px' }}
                pl="0"
                pr="0"
                mr={10}
                onClick={() => history.push('/settings/assignment-strategy')}
              >
                Assignment Strategy
              </Tab>
            )}
          </TabList>
        </Tabs>
        <Box mt="25px" padding="10px">
          {children}
        </Box>
      </>
    );
  },
);
